import { useScrollLock } from '@vueuse/core';

/**
 * Modal の表示制御に使用する Composable
 */
export const useModal = () => {
  const isOpen = ref<boolean>(false);

  const bodyElementRef = ref<HTMLElement | null>(null);
  onMounted(() => {
    bodyElementRef.value = document.body;
  });
  const isBackgroundLocked = useScrollLock(bodyElementRef);

  const open = async ({ autoClose } = { autoClose: false }) => {
    isOpen.value = true;

    if (!autoClose) return;

    setTimeout(() => {
      isOpen.value = false;
    }, 3000);
  };

  const close = async () => {
    isOpen.value = false;
  };

  watch([isOpen], () => {
    isBackgroundLocked.value = isOpen.value; // Modalが開いている間は、背景をスクロールできないようにする
  });

  return { open, close, isOpen };
};
